import {
  ChartGroupLayout,
  DashboardChartBase,
} from "@features/results/Result/Dashboard/dashboardModel"
import logger from "@utils/logger"

export const calculateContainerLayoutDashboardHeight = (
  chart: DashboardChartBase,
  layout: ChartGroupLayout,
) => {
  if (!chart.FillRows) return

  const [fromRow, toRow] = chart.FillRows.split("-").map(Number)

  if (fromRow === undefined || toRow === undefined) {
    logger.error(`Invalid "FillRows" value (${chart.FillRows}) of chart "${chart.Title}"`)
    return
  }

  const rowHeight = (layout.Height ?? 100) / (layout.NumberOfRows ?? 100)
  const usedRows = toRow - fromRow
  const height = rowHeight * usedRows

  return height
}
